import RecipeModule from "@/pages/sy/catalogs/recipes";
import ScrapMixAnalysis from "@/pages/sy/scrap-mix-analysis";
import ChargeManagement from "@/pages/sy/charges-management";
import ScrapLayeringReport from "@/pages/sy/scrap-layering-report";
import { RouteConfig } from "./types";

export const scrapRoutes: RouteConfig[] = [
  {
    path: "/scrap-charges/*",
    element: <ChargeManagement />,
    permission: "ui.navbar.scrap",
  },
  {
    path: "/scrap-recipes/*",
    element: <RecipeModule />,
    permission: "ui.navbar.scrap",
  },
  {
    path: "/scrap-layering-report/*",
    element: <ScrapLayeringReport />,
    permission: "ui.navbar.scrap",
  },
  {
    path: "/scrap-mix-analysis",
    element: <ScrapMixAnalysis />,
    permission: "ui.navbar.scrap.scrap-mix-analysis",
  },
];
